import React from 'react'
import PreviewFile from './file'
import PreviewSmartDocument from './smart-document'
import PreviewSmartTemplate from './smart-template'

const DocumentPreviewModal = props => {
    if(props.template) {
        return (
            <PreviewSmartTemplate
                {...props}
                id={props.template.id} />
        )
    }

    if(props.dokument?.type === 'smart') {
        return (
            <PreviewSmartDocument
                {...props}
                id={props.dokument.id} />
        )
    }

    return <PreviewFile {...props} />
}

export default DocumentPreviewModal